import { useEffect, useState } from 'react'
import { useArrivalWrite } from '../kufic/arrival-write'
import { useNewRowSoak } from './data-table-new-rows'

/**
 * The table body's two signatures: rows write themselves in after the loading
 * skeleton, and a row a save added later soaks in (`useNewRowSoak`).
 */
export function useDataTableArrival<T extends HTMLElement = HTMLTableSectionElement>(
  loading: boolean,
  rows: readonly { id: string }[] = [],
) {
  const [revealed, setRevealed] = useState(false)

  useEffect(() => {
    if (!loading) return
    setRevealed(false)
    const timer = window.setTimeout(() => setRevealed(true), 150)
    return () => window.clearTimeout(timer)
  }, [loading])

  const ref = useArrivalWrite<T>(!loading && revealed)
  useNewRowSoak(ref, loading ? null : rows.map((row) => row.id))
  return ref
}
